import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import PenTestToolMappingForm from "./PenTestToolMappingForm";

function PenTestToolCredentialsForm(props, ref) {

    const fields = [
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            rules: [urlRegexValidator],
            required: true,
        }, 
        {
            name: "token",
            label: "API Key",
            type: FieldTypes.PASSWORD,
            required: true
        }
    ];

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={PenTestToolMappingForm}
            initialValue={{ apiEndpoint: "https://app.pentest-tools.com" }}
        />
    );
}

export default forwardRef(PenTestToolCredentialsForm);